import React, { useRef, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { bp } from 'styles/breakpoints'
import { FadeInUpAnimationWrapper } from 'styles/animation'

import CarouselControls from 'components/Carousel/CarouselControls'
import CarouselItemModal from 'components/CarouselItemModal'
import ProductCard from './LifestyleProductCard/ProductCard'

import {
  Container,
  Background,
  ProductList,
  ProductContainer,
  StyledSlider,
  CarouselControlsWrapper,
} from './LifestyleProductsCarousel.style'

const LifestyleProductsCarousel = ({ products, hexValue }) => {
  const productModalRef = useRef(null)
  const productListRef = useRef(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const slider = useRef(null)

  const settings = {
    arrows: false,
    draggable: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    useCSS: true,
    centerPadding: 100,
    onInit: () => {
      setCurrentSlide(0)
    },
    beforeChange: (curr, next) => {
      setCurrentSlide(Math.ceil(next))
    },
    afterChange: (curr) => {
      setCurrentSlide(Math.ceil(curr))
    },
    onEdge: () => {},
    responsive: [
      {
        breakpoint: parseInt(bp[1].replace('px', ''), 10),
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  }

  const onCarouselControlClick = useCallback(
    (i) => {
      const ceiledPosition = Math.ceil(i)

      setCurrentSlide(ceiledPosition)

      if (slider.current) {
        slider.current.slickGoTo(ceiledPosition)
      }
    },
    [slider]
  )

  const villageName = products.map((product) => {
    return product?.brand?.village?.villageName
  })

  return (
    <Container hexValue={hexValue}>
      <Background hexValue={hexValue} />
      <ProductList ref={productListRef}>
        <StyledSlider {...settings} ref={slider}>
          {products.map((product, i) => {
            return (
              <FadeInUpAnimationWrapper enabled>
                <ProductContainer
                  key={`card_${i.toString()}`}
                  display={product.display}
                  selected={
                    i === Math.ceil(currentSlide) + 1 ||
                    i + products.length - 1 === Math.ceil(currentSlide)
                  }>
                  <ProductCard
                    {...product}
                    hasBackgroundHex={hexValue}
                    selected={
                      i === currentSlide + 1 ||
                      i + products.length - 1 === currentSlide
                    }
                    brand={product?.brand?.brandName}
                    onclickProductModal={() => {
                      if (productModalRef.current) {
                        productModalRef.current.openModal({
                          ...product,
                          villageName: product?.brand?.village?.villageName,
                          brand:
                            product.productBrandNameOverride ||
                            product?.brand?.brandName,
                        })
                      }
                    }}
                  />
                </ProductContainer>
              </FadeInUpAnimationWrapper>
            )
          })}
        </StyledSlider>
      </ProductList>
      {products.length > 2 ? (
        <CarouselControlsWrapper>
          <CarouselControls
            onSlideChange={onCarouselControlClick}
            currentSlide={currentSlide}
            totalSlides={products.length - 1}
            hasMultipleItemsPerView={false}
            isBoxed={false}
            isSmall
            isMobileOnly
            villageName={villageName}
          />
        </CarouselControlsWrapper>
      ) : null}
      <CarouselItemModal ref={productModalRef} />
    </Container>
  )
}

LifestyleProductsCarousel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  hexValue: PropTypes.string.isRequired,
}

LifestyleProductsCarousel.defaultProps = {
  id: '',
  title: '',
  subtitle: '',
  products: [],
}

export default LifestyleProductsCarousel
